import { Avatar } from "antd";
import Typography from "./Typography";
import { COLORS } from "../constants/Colors";
import _ from "lodash";
import { FormattedMessage,useIntl } from "react-intl";

const ProfileMenu = (props) => {
  const { onViewProfile, profileData } = props;

  return (
    <div className="d-flex flex-row px-4 py-3" >
      <Avatar size={46} className="mx-1" src={_.get(profileData, "profileImg")} />
      <div className="d-flex flex-column align-items-start pl-3">
        <Typography isBold className="pt-1">
        {profileData?.customerName?.split("•")[0]}
        </Typography>
        <Typography className="py-2" size="13px">
          {profileData?.phone}
        </Typography>
        <div onClick={onViewProfile}>
          <Typography
            isBold
            size="13px"
            color={COLORS.Primary}
            className="py-2"
            style={{ cursor: "pointer" }}
          >
            <FormattedMessage id="viewProfile" defaultMessage="View Profile" />
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
